import PropTypes from 'prop-types'
import { ForbiddenPage } from 'components/elements'
import List from 'containers/pages/calculationDplk/investmentHistory/List'
// import Form from 'containers/pages/calculatorManagement/dplkFee/Form'

const InvestmentHistory = ({ location, match, currentUser }) => {
  if (location.pathname === '/dplk-calculation-table/investment-history') {
    if (currentUser.permissions && currentUser.permissions.indexOf('manage-riwayat-hasil-pengembanganinvestment-history-read') > -1) {
      return <List location={location} />
    }
    return <ForbiddenPage />
  }
  // if (location.pathname.includes('/edit') || location.pathname.includes('/add')) {
  //   if (currentUser.permissions && currentUser.permissions.indexOf('manage-riwayat-hasil-pengembanganinvestment-history-write') > -1) {
  //     return <Form match={match} location={location} />
  //   }
  //   return <ForbiddenPage />
  // }
  return ''
}

InvestmentHistory.propTypes = {
  currentUser: PropTypes.object,
  location: PropTypes.object,
  match: PropTypes.object,
}

export default InvestmentHistory
